import { SecurityItemsKeys } from '@/enum/SecurityItems'
import { UiTab } from '@/models/ui/UiTab'

export const MISSIONS_DETAIL_TABS: Array<UiTab> = [
  new UiTab({
    label: 'MissionDetailMap',
    icon: 'mdi-map',
    group: 'Map',
    cmp: 'MissionDetailMap',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_MAP,
  }),
  new UiTab({
    label: 'MissionDetailMapLayer',
    icon: 'mdi-layers',
    group: 'Map',
    cmp: 'MissionDetailMapLayer',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_MAP_LAYER,
  }),
  new UiTab({
    label: 'MissionDetailScienceGraphics',
    icon: 'mdi-chart-histogram',
    group: 'Plot',
    cmp: 'MissionDetailScienceGraphics',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_CUSTOM_SCIENCE_PLOT,
  }),
  new UiTab({
    label: 'MissionDetailScienceGraphicsList',
    icon: 'mdi-view-grid',
    group: 'Plot',
    cmp: 'MissionDetailScienceGraphicsList',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS,
  }),
  new UiTab({
    label: 'MissionDetailNavigationGraphics',
    icon: 'mdi-chart-line',
    group: 'Plot',
    cmp: 'MissionDetailNavigationGraphics',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_CUSTOM_NAVIGATION_PLOT,
  }),
  new UiTab({
    label: 'MissionDetailNavigationGraphicsList',
    icon: 'mdi-grid',
    group: 'Plot',
    cmp: 'MissionDetailNavigationGraphicsList',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS,
  }),
  new UiTab({
    label: 'MissionDetailNmeaGraphics',
    icon: 'mdi-chart-line',
    group: 'Plot',
    cmp: 'MissionDetailNmeaGraphics',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_CUSTOM_NMEA_PLOT,
  }),
  new UiTab({
    label: 'MissionDetailNmeaGraphicsList',
    icon: 'mdi-grid',
    group: 'Plot',
    cmp: 'MissionDetailNmeaGraphicsList',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_MAIN_NMEA_PLOTS,
  }),
  //new UiTab({label:'CacheAllGraphicsList',icon:"mdi-grid", group:'Plot', cmp:'CacheAllGraphicsList',securityKey:SecurityItemsKeys.PILOT_DETAIL_MAIN_NAVIGATION_PLOTS}),
  new UiTab({
    label: 'MissionEndSimulationSinglePlots',
    icon: 'mdi-chart-bar',
    group: 'Plot',
    cmp: 'MissionEndSimulationSinglePlots',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_CUSTOM_NMEA_PLOT,
  }),
  new UiTab({
    label: 'MissionEndSimulationSinglePlotsList',
    icon: 'mdi-chart-bar',
    group: 'Plot',
    cmp: 'MissionEndSimulationSinglePlotsList',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_MAIN_SCIENCE_PLOTS,
  }),

  new UiTab({
    label: 'MissionDetailAd2cp',
    icon: 'mdi-sync',
    group: 'Plot',
    cmp: 'MissionDetailAd2cp',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_AD2CP,
    iris: true,
    irisModule: 'AD2CP',
  }),
  new UiTab({
    label: 'MissionDetailImage',
    icon: 'mdi-image',
    group: 'Plot',
    cmp: 'MissionDetailImage',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_IMAGE,
    iris: true,
  }),

  new UiTab({
    label: 'MissionDetailConsole',
    icon: 'mdi-console',
    group: 'Pilotage',
    cmp: 'MissionDetailConsole',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE,
  }),
  new UiTab({
    label: 'MissionDetailNextSurfacingDo',
    icon: 'mdi-google-circles-group',
    group: 'Pilotage',
    cmp: 'MissionDetailNextSurfacingDo',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_NEXT_SURFACING_DO,
    mustBeActive: true,
    iris: true,
    irisModule: 'NextSurfacingDo',
  }),
  new UiTab({
    label: 'MissionDetailSingleWayPoint',
    icon: 'mdi-map-marker',
    group: 'Pilotage',
    cmp: 'MissionDetailSingleWayPoint',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_SINGLE_WAY_POINT,
    mustBeActive: true,
    iris: true,
    irisModule: 'SingleWayPoint',
  }),
  new UiTab({
    label: 'MissionDetailMissionPlan',
    icon: 'mdi-group',
    group: 'Pilotage',
    cmp: 'MissionDetailMissionPlan',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_MISSION_PLANNING,
    iris: true,
    irisModule: 'MissionPlan',
    checkBeforeClose: true,
  }),
  new UiTab({
    label: 'MissionDetailFleetManagement',
    icon: 'mdi-shape-plus',
    group: 'Pilotage',
    cmp: 'MissionDetailFleetManagement',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_FLEET_MANAGEMENT,
  }),
  new UiTab({
    label: 'MissionDetailAnticollision',
    icon: 'mdi-ferry',
    group: 'Pilotage',
    cmp: 'MissionDetailAnticollision',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_ANTICOLLISION,
    mustBeActive: true,
    iris: true,
    irisModule: 'AIS',
  }),
  new UiTab({
    label: 'MissionDetailQuickControl',
    icon: 'mdi-lightning-bolt',
    group: 'Pilotage',
    cmp: 'MissionDetailQuickControl',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_QUICK_CONTROL,
    iris: true,
    irisModule: 'QuickControl',
    mustBeActive: false,
  }),
  new UiTab({
    label: 'MissionDetailEncryption',
    icon: 'mdi-key',
    group: 'Pilotage',
    cmp: 'MissionDetailEncryption',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_ENCRYPTION,
  }),

  new UiTab({
    label: 'MissionDetailLogBook',
    icon: 'mdi-comment-text-outline',
    group: 'Infos',
    cmp: 'MissionDetailLogBook',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_LOGBOOK,
  }),
  new UiTab({
    label: 'MissionDetailSendMail',
    icon: 'mdi-email',
    group: 'Infos',
    cmp: 'MissionDetailSendMail',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_SEND_MAIL,
    iris: true,
    irisModule: 'SendMail',
  }),
  //new UiTab({label:'MissionDetailInformation',icon:"mdi-newspaper", group:'Infos', cmp:'MissionDetailInformation',securityKey:SecurityItemsKeys.PILOT_DETAIL_INFORMATION_PANEL}),

  new UiTab({
    label: 'MissionDetailFileTransfer',
    icon: 'mdi-file',
    group: 'Config',
    cmp: 'MissionDetailFileTransfer',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_FILE_TRANSFERT,
    iris: true,
    irisModule: 'FileTransfer',
  }),
  new UiTab({
    label: 'MissionDetailFileUpload',
    icon: 'mdi-file-upload',
    group: 'Config',
    cmp: 'MissionDetailFileUpload',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_FILE_UPLOAD,
  }),
  new UiTab({
    label: 'MissionDetailFtpRsync',
    icon: 'mdi-folder-sync',
    group: 'Config',
    cmp: 'MissionDetailFtpRsync',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_FTP_RSYNC,
    iris: true,
    irisModule: 'FtpRsync',
  }),
  new UiTab({
    label: 'MissionDetailCoriolis',
    icon: 'mdi-folder-sync',
    group: 'Config',
    cmp: 'MissionDetailCoriolis',
    securityKey: SecurityItemsKeys.PILOT_DETAIL_CORIOLIS,
    iris: true,
    irisModule: 'Coriolis',
  }),

  //
]
